const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid #8a6a00', fontFamily:"'Georgia', serif", color:'#1a1200', lineHeight:'1.7', background:'#fffdf0' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #d4a000', paddingBottom:'8px', marginBottom:'24px', color:'#7a4f00' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#b88000', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #d4a000', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#fffbe6', border:'2px solid #d4a000', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7a4f00', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #d4a000' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#b88000', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0d98a', verticalAlign:'top', background:'#fffbee' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0d98a', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7a4f00', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffdf5', border:'1px solid #e8c84a', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7a4f00', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#666', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Detail</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── helpers ──────────────────────────────────────────────────────────
const arr = (n) => Array.from({ length: n }, (_, i) => i);

// ── Diagram 1: PWM Anatomy — period, duty, edges ────────────────────
function DiagramAnatomy() {
  const W = 900, H = 280;
  // Waveform occupies left 52%, info boxes occupy right 46%
  const sx = 60, ex = 470;
  const Vhi = 50, Vlo = 130;
  const nPeriods = 3;
  const T = (ex - sx) / nPeriods;
  const duty = 0.62;

  const pts = [];
  for (let i = 0; i < nPeriods; i++) {
    const x0 = sx + i * T;
    const xOn = x0 + duty * T;
    if (i === 0) pts.push([x0, Vlo]);
    pts.push([x0, Vhi]);
    pts.push([xOn, Vhi]);
    pts.push([xOn, Vlo]);
    pts.push([x0 + T, Vlo]);
  }
  const pathD = 'M ' + pts.map(p => p.join(',')).join(' L ');
  const avgY = Vhi + (Vlo - Vhi) * (1 - duty);

  // Info boxes: start at x=490, width=400, end at 890 < W=900
  const bx = 490, bw = 400, bMid = bx + bw / 2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>PWM Signal Anatomy — Period, Duty Cycle, Rise/Fall Edges, Average Voltage</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aA" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#7a4f00"/>
          </marker>
          <marker id="aAr" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto-start-reverse">
            <polygon points="0 0,6 3.5,0 7" fill="#7a4f00"/>
          </marker>
        </defs>

        {/* Axis */}
        <line x1={sx-8} y1={Vhi-10} x2={sx-8} y2={Vlo+10} stroke="#7a4f00" strokeWidth="1.5"/>
        <text x={sx-12} y={Vhi+4} textAnchor="end" fontSize="10" fill="#d4a000" fontFamily="'Courier New',monospace">V_high</text>
        <text x={sx-12} y={Vlo+4} textAnchor="end" fontSize="10" fill="#888"    fontFamily="'Courier New',monospace">0 V</text>

        {/* Average voltage line — stops before info boxes */}
        <line x1={sx} y1={avgY} x2={ex - 30} y2={avgY} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="7,4"/>
        <text x={ex - 24} y={avgY - 6} fontSize="9" fill="#e07b00" fontWeight="700" textAnchor="middle">V_avg</text>

        {/* Waveform */}
        <path d={pathD} fill="none" stroke="#d4a000" strokeWidth="3" strokeLinejoin="round"/>

        {/* Shaded ON regions */}
        {arr(nPeriods).map(i => (
          <rect key={i} x={sx+i*T} y={Vhi} width={duty*T} height={Vlo-Vhi} fill="#d4a000" opacity="0.10"/>
        ))}

        {/* Period brace */}
        <line x1={sx} y1={Vlo+22} x2={sx+T} y2={Vlo+22} stroke="#7a4f00" strokeWidth="1.5"
          markerStart="url(#aAr)" markerEnd="url(#aA)"/>
        <text x={sx+T/2} y={Vlo+38} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a4f00">T = 1/f_pwm</text>

        {/* t_on brace */}
        <line x1={sx} y1={Vhi-20} x2={sx+duty*T} y2={Vhi-20} stroke="#d4a000" strokeWidth="1.5"
          markerStart="url(#aAr)" markerEnd="url(#aA)"/>
        <text x={sx+duty*T/2} y={Vhi-28} textAnchor="middle" fontSize="10" fontWeight="700" fill="#d4a000">t_on</text>

        {/* t_off brace */}
        <line x1={sx+duty*T} y1={Vhi-20} x2={sx+T} y2={Vhi-20} stroke="#b88000" strokeWidth="1.5"
          markerStart="url(#aAr)" markerEnd="url(#aA)"/>
        <text x={sx+duty*T+(1-duty)*T/2} y={Vhi-28} textAnchor="middle" fontSize="10" fontWeight="700" fill="#b88000">t_off</text>

        {/* Edge annotations */}
        <line x1={sx} y1={Vlo} x2={sx} y2={Vhi} stroke="#d4a000" strokeWidth="1" strokeDasharray="3,2" opacity="0.5"/>
        <text x={sx+4} y={(Vhi+Vlo)/2} fontSize="9" fill="#d4a000">↑ rise</text>
        <line x1={sx+duty*T} y1={Vhi} x2={sx+duty*T} y2={Vlo} stroke="#b88000" strokeWidth="1" strokeDasharray="3,2" opacity="0.5"/>
        <text x={sx+duty*T+4} y={(Vhi+Vlo)/2} fontSize="9" fill="#b88000">↓ fall</text>

        {/* Duty cycle box — right panel, fully inside W */}
        <rect x={bx} y={30} width={bw} height={110} rx={5} fill="#fffbe6" stroke="#d4a000"/>
        <text x={bMid} y={52}  textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a4f00">Duty Cycle D</text>
        <text x={bMid} y={72}  textAnchor="middle" fontSize="13" fill="#d4a000" fontFamily="'Courier New',monospace">D = t_on / T</text>
        <text x={bMid} y={90}  textAnchor="middle" fontSize="11" fill="#d4a000" fontFamily="'Courier New',monospace">V_avg = D × V_high</text>
        <text x={bMid} y={108} textAnchor="middle" fontSize="9"  fill="#888">D=0 → 0V out    D=1 → V_high out</text>
        <text x={bMid} y={124} textAnchor="middle" fontSize="9"  fill="#888">This example: D=62%  → V_avg = 0.62 × V_high</text>

        {/* Frequency box */}
        <rect x={bx} y={152} width={bw} height={90} rx={5} fill="#fffbe6" stroke="#b88000"/>
        <text x={bMid} y={172} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a4f00">Frequency f_pwm</text>
        <text x={bMid} y={192} textAnchor="middle" fontSize="13" fill="#b88000" fontFamily="'Courier New',monospace">f = 1/T</text>
        <text x={bMid} y={210} textAnchor="middle" fontSize="9"  fill="#888">Controls ripple, noise, loss, response speed</text>
        <text x={bMid} y={226} textAnchor="middle" fontSize="9"  fill="#888">Typical: 1 kHz – 2 MHz depending on application</text>
      </svg>
      <div style={S.dCaption}>The switch spends D×100% of each period in the ON state. The load's natural filtering (L or C) converts the switching waveform into a nearly smooth DC level.</div>
    </div>
  );
}

// ── Diagram 2: Edge-Aligned vs Centre-Aligned ─────────────────────────
function DiagramAlignment() {
  const W = 900, H = 300;
  const sx = 50, ex = 560;
  const T = (ex - sx) / 4;          // 4 periods visible
  const duty = 0.55;
  const Vhi = 30, Vlo = 80;
  const carriH = 140, carriLo = 200;

  const buildEdge = (startX, nP, d) => {
    const pts = [];
    for (let i = 0; i < nP; i++) {
      const x0 = startX + i * T;
      if (i === 0) pts.push([x0, Vlo]);
      pts.push([x0, Vhi]);
      pts.push([x0 + d*T, Vhi]);
      pts.push([x0 + d*T, Vlo]);
      pts.push([x0 + T, Vlo]);
    }
    return 'M ' + pts.map(p=>p.join(',')).join(' L ');
  };

  const buildCenter = (startX, nP, d) => {
    const half = (1-d)*T/2;
    const pts = [];
    for (let i = 0; i < nP; i++) {
      const x0 = startX + i*T;
      if (i===0) pts.push([x0, Vlo]);
      pts.push([x0 + half, Vlo]);
      pts.push([x0 + half, Vhi]);
      pts.push([x0 + half + d*T, Vhi]);
      pts.push([x0 + half + d*T, Vlo]);
      pts.push([x0 + T, Vlo]);
    }
    return 'M ' + pts.map(p=>p.join(',')).join(' L ');
  };

  // Carrier waves
  const sawtooth = arr(5).map(i => `${sx+i*T},${carriLo} ${sx+(i+0)*T},${carriH}`).join(' ');
  const triangle = (() => {
    const pts = [];
    for (let i=0; i<=4*2; i++) {
      const x = sx + i*T/2;
      pts.push(`${x},${i%2===0?carriLo:carriH}`);
    }
    return pts.join(' ');
  })();

  // Ref line at duty level
  const refY = carriH + (carriLo-carriH)*(1-duty);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Edge-Aligned (Sawtooth) vs Centre-Aligned (Triangle) PWM — Carrier & Output</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* ── LEFT: Edge-aligned ── */}
        <text x={sx} y={16} fontSize="11" fontWeight="700" fill="#d4a000">Edge-Aligned (Asymmetric) PWM</text>

        {/* Sawtooth carrier */}
        <text x={sx-4} y={carriH+4} textAnchor="end" fontSize="9" fill="#888">carrier</text>
        <polyline points={sawtooth} fill="none" stroke="#e8c84a" strokeWidth="1.5" strokeDasharray="4,2"/>
        <line x1={sx} y1={refY} x2={ex} y2={refY} stroke="#d4a000" strokeWidth="1.2" strokeDasharray="5,3"/>
        <text x={ex+4} y={refY+4} fontSize="9" fill="#d4a000">ref</text>

        {/* Edge-aligned PWM output */}
        <text x={sx-4} y={Vhi+4} textAnchor="end" fontSize="9" fill="#888">output</text>
        <path d={buildEdge(sx,4,duty)} fill="none" stroke="#d4a000" strokeWidth="2.5"/>

        {/* Switching event markers (edge-aligned: all at left edge) */}
        {arr(4).map(i => (
          <line key={i} x1={sx+i*T} y1={Vhi-8} x2={sx+i*T} y2={carriLo+8}
            stroke="#d4a000" strokeWidth="0.8" strokeDasharray="2,2" opacity="0.4"/>
        ))}
        <text x={sx+T/2} y={Vlo+20} textAnchor="middle" fontSize="9" fill="#d4a000">all edges at period start</text>

        {/* ── RIGHT: Centre-aligned ── */}
        const rsx = ex + 80;
        <text x={ex+80} y={16} fontSize="11" fontWeight="700" fill="#b88000">Centre-Aligned (Symmetric) PWM</text>

        {/* Triangle carrier */}
        <text x={ex+76} y={carriH+4} textAnchor="end" fontSize="9" fill="#888">carrier</text>
        <polyline points={arr(4*2+1).map(i=>`${ex+80+i*T/2},${i%2===0?carriLo:carriH}`).join(' ')}
          fill="none" stroke="#e8c84a" strokeWidth="1.5" strokeDasharray="4,2"/>
        <line x1={ex+80} y1={refY} x2={W-10} y2={refY} stroke="#b88000" strokeWidth="1.2" strokeDasharray="5,3"/>
        <text x={W-6} y={refY+4} fontSize="9" fill="#b88000">ref</text>

        {/* Centre-aligned PWM output */}
        <text x={ex+76} y={Vhi+4} textAnchor="end" fontSize="9" fill="#888">output</text>
        <path d={buildCenter(ex+80,4,duty)} fill="none" stroke="#b88000" strokeWidth="2.5"/>

        {/* Midpoint markers */}
        {arr(4).map(i => (
          <line key={i} x1={ex+80+i*T+T/2} y1={Vhi-8} x2={ex+80+i*T+T/2} y2={carriLo+8}
            stroke="#b88000" strokeWidth="0.8" strokeDasharray="2,2" opacity="0.4"/>
        ))}
        <text x={ex+80+T*2} y={Vlo+20} textAnchor="middle" fontSize="9" fill="#b88000">symmetric around midpoint</text>

        {/* Comparison callout */}
        <rect x={50} y={220} width={820} height={68} rx={5} fill="#fffbe6" stroke="#d4a000"/>
        <text x={60} y={238} fontSize="10" fontWeight="700" fill="#7a4f00">Edge-Aligned:</text>
        <text x={60} y={252} fontSize="9" fill="#333">Single switching edge per period. Higher EMI at harmonics of f_pwm. Simple to implement. ADC sampling difficult — noise at edges.</text>
        <text x={60} y={266} fontSize="9" fill="#333">Used in: simple LED dimmers, basic DC motor speed control, servo signal generation (50 Hz, 1–2 ms pulse).</text>
        <text x={60} y={282} fontSize="10" fontWeight="700" fill="#b88000">Centre-Aligned:</text>
        <text x={60} y={296} fontSize="9" fill="#333">Two switching edges symmetrically placed. Half the effective ripple current. ADC can sample at exact midpoint (no switching noise). Preferred in motor control and high-quality audio DACs.</text>
      </svg>
      <div style={S.dCaption}>Centre-aligned PWM doubles effective ripple frequency seen by the load, halving ΔI without changing f_pwm or switching losses.</div>
    </div>
  );
}

// ── Diagram 3: Duty Cycle vs Average Voltage & Ripple ───────────────
function DiagramDutySweep() {
  const W = 900, H = 300;
  const gx = 60, gy = 240, gw = 340, gh = 190;  // narrower graph leaves room for panel
  const nPts = 100;

  // V_avg = D * Vdc (linear, normalised Vdc=1)
  const avgPts = arr(nPts+1).map(i => {
    const d = i/nPts;
    return { x: gx + d*gw, y: gy - d*gh };
  });

  // Ripple ΔI ∝ D(1-D) — peak at D=0.5
  const ripplePts = arr(nPts+1).map(i => {
    const d = i/nPts;
    return { x: gx + d*gw, y: gy - d*(1-d)*4*gh };
  });

  const toPath = pts => 'M '+pts.map(p=>`${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' L ');

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Average Output Voltage and Current Ripple vs Duty Cycle</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aD" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#7a4f00"/>
          </marker>
        </defs>

        {/* Axes */}
        <line x1={gx} y1={gy} x2={gx+gw+20} y2={gy} stroke="#7a4f00" strokeWidth="2" markerEnd="url(#aD)"/>
        <line x1={gx} y1={gy} x2={gx}        y2={gy-gh-20} stroke="#7a4f00" strokeWidth="2" markerEnd="url(#aD)"/>
        <text x={gx+gw+24} y={gy+5} fontSize="11" fill="#7a4f00" fontWeight="700">D</text>
        <text x={gx-8} y={gy-gh-24} fontSize="9" fill="#7a4f00">value</text>

        {/* Tick marks */}
        {[0,0.25,0.5,0.75,1].map((d,i)=>(
          <g key={i}>
            <line x1={gx+d*gw} y1={gy} x2={gx+d*gw} y2={gy+5} stroke="#7a4f00" strokeWidth="1.2"/>
            <text x={gx+d*gw} y={gy+16} textAnchor="middle" fontSize="9" fill="#7a4f00">{d}</text>
          </g>
        ))}
        {[0,0.5,1].map((v,i)=>(
          <g key={i}>
            <line x1={gx-4} y1={gy-v*gh} x2={gx} y2={gy-v*gh} stroke="#7a4f00" strokeWidth="1.2"/>
            <text x={gx-8} y={gy-v*gh+4} textAnchor="end" fontSize="9" fill="#7a4f00">{v}</text>
          </g>
        ))}

        {/* Grid */}
        {[0.25,0.5,0.75].map((d,i)=>(
          <line key={i} x1={gx+d*gw} y1={gy} x2={gx+d*gw} y2={gy-gh} stroke="#e8c84a" strokeWidth="0.6" strokeDasharray="3,3"/>
        ))}

        {/* V_avg line */}
        <path d={toPath(avgPts)} fill="none" stroke="#d4a000" strokeWidth="3"/>
        <text x={gx+gw+8} y={gy-gh+4} fontSize="10" fontWeight="700" fill="#d4a000">V_avg = D·V_dc</text>

        {/* Ripple curve */}
        <path d={toPath(ripplePts)} fill="none" stroke="#e07b00" strokeWidth="2.5" strokeDasharray="6,3"/>
        <text x={gx+gw*0.5+8} y={gy-gh*0.95} fontSize="10" fontWeight="700" fill="#e07b00">ΔI ∝ D(1−D)</text>

        {/* Peak ripple marker */}
        <circle cx={gx+0.5*gw} cy={gy-gh} r={5} fill="#e07b00"/>
        <line x1={gx+0.5*gw} y1={gy-gh} x2={gx+0.5*gw} y2={gy} stroke="#e07b00" strokeWidth="0.8" strokeDasharray="3,2" opacity="0.4"/>
        <text x={gx+0.5*gw+6} y={gy-gh-8} fontSize="9" fill="#e07b00">peak ripple at D=0.5</text>

        {/* Right panel — ripple formula */}
        <rect x={430} y={20} width={462} height={240} rx={6} fill="#fffbe6" stroke="#d4a000"/>
        <text x={661} y={44} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a4f00">Ripple Equations</text>

        {[
          { label:'Current ripple (inductor):', eqn:'ΔI_L = V_dc·D·(1−D) / (L·f_pwm)', color:'#e07b00' },
          { label:'Voltage ripple (capacitor):', eqn:'ΔV_C = I_load / (C·f_pwm)', color:'#b88000' },
          { label:'Peak ripple at:', eqn:'D = 0.5  →  ΔI = V_dc / (4·L·f_pwm)', color:'#e07b00' },
          { label:'Ripple-to-average ratio:', eqn:'ΔI/I_avg = (1−D) / (L·f·I_avg/V_dc)', color:'#d4a000' },
          { label:'To halve ΔI, double either:', eqn:'f_pwm  (×2 loss)  or  L  (×2 size/cost)', color:'#b88000' },
          { label:'Effective ripple (centre-aligned):', eqn:'Appears at 2×f_pwm to the load\nSame switching loss, half the ripple', color:'#c49000' },
        ].map((item, i) => (
          <g key={i}>
            <text x={440} y={66+i*32} fontSize="9" fontWeight="700" fill={item.color}>{item.label}</text>
            {item.eqn.split('\n').map((l,li)=>(
              <text key={li} x={440} y={78+i*32+li*12} fontSize="9" fill="#333" fontFamily="'Courier New',monospace">{l}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>V_avg is perfectly linear with D — this is what makes PWM ideal for linear control. Ripple is worst at 50% duty and zero at 0% and 100%.</div>
    </div>
  );
}

// ── Diagram 4: Frequency Domain — Harmonics ──────────────────────────
function DiagramHarmonics() {
  const W = 900, H = 260;
  const gx = 60, gy = 210, gw = 500, gh = 170;

  // PWM spectrum: DC + fundamental at f_pwm + harmonics at n×f_pwm
  // Amplitude of nth harmonic of a square wave: |a_n| = (2·V_dc/(n·π))·|sin(n·π·D)|
  const D = 0.4;
  const Vdc = 1;
  const harmonics = arr(9).map(n => {
    const freq = n; // normalised to f_pwm
    const amp  = n === 0
      ? D * Vdc                                                  // DC component
      : Math.abs(2 * Vdc / (n * Math.PI) * Math.sin(n * Math.PI * D));
    return { freq, amp };
  });

  const maxAmp = Math.max(...harmonics.map(h => h.amp));

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>PWM Frequency Spectrum — DC Component + Harmonics at n × f_pwm  (D = 40 %)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aH" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#7a4f00"/>
          </marker>
        </defs>

        {/* Axes */}
        <line x1={gx} y1={gy} x2={gx+gw+30} y2={gy} stroke="#7a4f00" strokeWidth="2" markerEnd="url(#aH)"/>
        <line x1={gx} y1={gy+4} x2={gx}      y2={gy-gh-20} stroke="#7a4f00" strokeWidth="2" markerEnd="url(#aH)"/>
        <text x={gx+gw+36} y={gy+5} fontSize="11" fill="#7a4f00">Frequency</text>
        <text x={gx-8} y={gy-gh-22} fontSize="9" fill="#7a4f00" textAnchor="end">Amplitude</text>

        {harmonics.map((h, i) => {
          const barW = 34;
          const barH = (h.amp / maxAmp) * gh;
          const bx = gx + i * (gw / (harmonics.length - 0.5));
          const col = i === 0 ? '#c49000' : (i === 1 ? '#d4a000' : '#b88000');
          const label = i === 0 ? 'DC\n(0 Hz)' : `n=${i}\n${i}×f`;
          return (
            <g key={i}>
              <rect x={bx-barW/2} y={gy-barH} width={barW} height={barH} rx={3} fill={col} opacity="0.88"/>
              {label.split('\n').map((l, li) => (
                <text key={li} x={bx} y={gy+14+li*13} textAnchor="middle" fontSize="9" fill="#7a4f00">{l}</text>
              ))}
              <text x={bx} y={gy-barH-6} textAnchor="middle" fontSize="9" fill={col} fontFamily="'Courier New',monospace">
                {h.amp.toFixed(2)}
              </text>
            </g>
          );
        })}

        {/* Envelope line */}
        {(() => {
          const envPts = harmonics.slice(1).map((h, i) => {
            const bx = gx + (i+1) * (gw / (harmonics.length - 0.5));
            const barH = (h.amp / maxAmp) * gh;
            return `${bx},${gy-barH}`;
          });
          return <polyline points={envPts.join(' ')} fill="none" stroke="#e07b00" strokeWidth="1.5" strokeDasharray="5,3"/>;
        })()}
        <text x={gx+gw-60} y={gy-gh*0.3} fontSize="9" fill="#e07b00" fontStyle="italic">1/(n·π) envelope</text>

        {/* Filter cut-off annotation */}
        <line x1={gx+gw*0.15} y1={gy-gh-14} x2={gx+gw*0.15} y2={gy+4}
          stroke="#b88000" strokeWidth="1.5" strokeDasharray="5,3"/>
        <text x={gx+gw*0.15+4} y={gy-gh-6} fontSize="9" fill="#b88000" fontWeight="700">← filter cuts here</text>
        <text x={gx+gw*0.15+4} y={gy-gh+6} fontSize="9" fill="#b88000">f_c {'<'} f_pwm</text>

        {/* Right annotations */}
        <rect x={610} y={20} width={275} height={200} rx={5} fill="#fffbe6" stroke="#d4a000"/>
        <text x={747} y={40} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a4f00">Harmonic Content</text>
        {[
          ['DC term (n=0)', 'Amplitude = D·V_dc\nDesired output component'],
          ['Fundamental (n=1)', 'At f_pwm — must be filtered\nAmp = (2V_dc/π)·sin(π·D)'],
          ['n-th harmonic', 'At n·f_pwm, amp ∝ 1/n\nHigher harmonics roll off naturally'],
          ['THD reduction', 'Higher f_pwm → harmonics further\naway from signal band → easier filter'],
          ['EMI concern', 'Harmonics radiate — spread spectrum\nPWM randomises f slightly to spread'],
        ].map(([t,b],i)=>(
          <g key={i}>
            <text x={620} y={58+i*32} fontSize="9" fontWeight="700" fill="#b88000">{t}:</text>
            {b.split('\n').map((l,li)=>(
              <text key={li} x={620} y={70+i*32+li*11} fontSize="8" fill="#333">{l}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>A PWM signal is mathematically a Fourier series. The load's filtering extracts only the DC term; all harmonics must be attenuated sufficiently.</div>
    </div>
  );
}

// ── Diagram 5: Buck Converter with PWM ───────────────────────────────
function DiagramBuck() {
  const W = 900, H = 310;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Buck (Step-Down) Converter — PWM Control of Switch Duty Cycle Sets V_out</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aBuck" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
          <marker id="aBuckB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#b88000"/>
          </marker>
        </defs>

        {/* ── Schematic left half ── */}
        {/* V_in source */}
        <rect x={20} y={100} width={60} height={110} rx={5} fill="#c49000" opacity="0.85"/>
        <text x={50} y={148} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">V_in</text>
        <text x={50} y={164} textAnchor="middle" fontSize="10" fill="#fff9cc">e.g. 12V</text>

        {/* Top wire from V_in → switch */}
        <line x1={80} y1={115} x2={160} y2={115} stroke="#e07b00" strokeWidth="3"/>

        {/* PWM Switch */}
        <rect x={160} y={95} width={80} height={50} rx={5} fill="#d4a000" opacity="0.9"/>
        <text x={200} y={117} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">PWM</text>
        <text x={200} y={132} textAnchor="middle" fontSize="9" fill="#fff9cc">Switch / FET</text>

        {/* Switch node → inductor */}
        <line x1={240} y1={120} x2={300} y2={120} stroke="#d4a000" strokeWidth="3"/>
        <text x={270} y={112} textAnchor="middle" fontSize="9" fill="#7a4f00">V_sw</text>

        {/* Inductor */}
        {arr(4).map(i => (
          <path key={i} d={`M ${300+i*20},120 Q ${310+i*20},100 ${320+i*20},120`}
            fill="none" stroke="#b88000" strokeWidth="3"/>
        ))}
        <text x={340} y={148} textAnchor="middle" fontSize="10" fill="#b88000" fontWeight="700">L</text>

        {/* After inductor → load */}
        <line x1={380} y1={120} x2={480} y2={120} stroke="#d4a000" strokeWidth="3"/>

        {/* Freewheeling diode */}
        <line x1={310} y1={120} x2={310} y2={190} stroke="#888" strokeWidth="2"/>
        <polygon points="300,190 310,170 320,190" fill="#888"/>
        <line x1={300} y1={190} x2={320} y2={190} stroke="#888" strokeWidth="2"/>
        <text x={330} y={178} fontSize="9" fill="#888">D_fw</text>
        <line x1={310} y1={190} x2={310} y2={210} stroke="#888" strokeWidth="2"/>

        {/* Capacitor */}
        <line x1={460} y1={120} x2={460} y2={155} stroke="#b88000" strokeWidth="2.5"/>
        <line x1={442} y1={155} x2={478} y2={155} stroke="#b88000" strokeWidth="3.5"/>
        <line x1={442} y1={163} x2={478} y2={163} stroke="#b88000" strokeWidth="3.5"/>
        <line x1={460} y1={163} x2={460} y2={210} stroke="#b88000" strokeWidth="2.5"/>
        <text x={484} y={162} fontSize="10" fill="#b88000" fontWeight="700">C</text>

        {/* Load */}
        <rect x={500} y={100} width={70} height={110} rx={5} fill="#c49000" opacity="0.8"/>
        <text x={535} y={148} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">Load</text>
        <text x={535} y={164} textAnchor="middle" fontSize="10" fill="#fff9cc">V_out</text>

        {/* Ground rail */}
        <line x1={80} y1={210} x2={570} y2={210} stroke="#555" strokeWidth="2.5"/>
        <line x1={80} y1={210} x2={80} y2={205} stroke="#555" strokeWidth="2.5"/>
        <line x1={80} y1={210} x2={80} y2={115} stroke="#555" strokeWidth="2.5"/>
        <line x1={500} y1={120} x2={570} y2={120} stroke="#d4a000" strokeWidth="3"/>
        <line x1={570} y1={120} x2={570} y2={210} stroke="#d4a000" strokeWidth="2.5"/>

        {/* ── Waveforms right half ── */}
        {(()=>{
          const wx=608, wy0=20, wW=255, periods=4, T2=255/4, D2=0.6;
          const iBase=wy0+100, iAmp=16;
          const ilPts=[];
          for(let i=0;i<periods;i++){
            const x0=wx+i*T2;
            if(i===0) ilPts.push([x0,iBase]);
            ilPts.push([x0,iBase+iAmp/2]);
            ilPts.push([x0+D2*T2,iBase-iAmp/2]);
            ilPts.push([x0+T2,iBase+iAmp/2]);
          }
          const voPts=[];
          const base=wy0+152, amp=2.5;
          for(let i=0;i<periods*4+1;i++){
            const x=wx+i*T2/4;
            voPts.push([x, base+amp*Math.sin(i*Math.PI/2)]);
          }
          return (
            <g>
              {/* V_sw waveform */}
              <text x={wx} y={wy0+14} fontSize="10" fontWeight="700" fill="#d4a000">V_sw</text>
              {arr(periods).map(i=>{
                const x0=wx+i*T2;
                return (
                  <g key={i}>
                    <rect x={x0} y={wy0+20} width={D2*T2} height={28} rx={2} fill="#d4a000" opacity="0.85"/>
                    {i===0 && <text x={x0+D2*T2/2} y={wy0+38} textAnchor="middle" fontSize="8" fill="#fff">V_in</text>}
                    {i===0 && <text x={x0+D2*T2+(1-D2)*T2/2} y={wy0+54} textAnchor="middle" fontSize="8" fill="#888">0V</text>}
                  </g>
                );
              })}
              {/* I_L waveform */}
              <text x={wx} y={wy0+70} fontSize="10" fontWeight="700" fill="#b88000">I_L</text>
              <path d={'M '+ilPts.map(p=>p.join(',')).join(' L ')} fill="none" stroke="#b88000" strokeWidth="2.5"/>
              <line x1={wx} y1={wy0+100} x2={wx+wW} y2={wy0+100} stroke="#b88000" strokeWidth="0.8" strokeDasharray="4,3" opacity="0.5"/>
              <text x={wx+wW+4} y={wy0+104} fontSize="8" fill="#b88000">I_avg</text>
              {/* V_out nearly flat */}
              <text x={wx} y={wy0+124} fontSize="10" fontWeight="700" fill="#e07b00">V_out</text>
              <path d={'M '+voPts.map(p=>`${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' L ')} fill="none" stroke="#e07b00" strokeWidth="2"/>
              <line x1={wx} y1={wy0+152} x2={wx+wW} y2={wy0+152} stroke="#e07b00" strokeWidth="0.8" strokeDasharray="4,3" opacity="0.5"/>
              <text x={wx+wW+4} y={wy0+156} fontSize="8" fill="#e07b00">D·V_in</text>
              {/* Gain annotation */}
              <rect x={wx} y={wy0+186} width={wW} height={40} rx={4} fill="#fffbe6" stroke="#d4a000"/>
              <text x={wx+wW/2} y={wy0+202} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a4f00">Buck: V_out = D × V_in</text>
              <text x={wx+wW/2} y={wy0+218} textAnchor="middle" fontSize="9" fill="#888">D=0.6 → V_out=60%×V_in</text>
            </g>
          );
        })()}

        {/* Feedback arrow */}
        <path d="M 535,100 Q 535,60 450,60 Q 200,60 200,90"
          fill="none" stroke="#b88000" strokeWidth="1.8" strokeDasharray="5,3"
          markerEnd="url(#aBuckB)"/>
        <text x={360} y={52} textAnchor="middle" fontSize="9" fill="#b88000">feedback → adjust D to regulate V_out</text>

        {/* Boost/Buck-boost note */}
        <rect x={20} y={232} width={560} height={58} rx={4} fill="#fffbe6" stroke="#b88000"/>
        <text x={30} y={248} fontSize="10" fontWeight="700" fill="#7a4f00">Related topologies using PWM:</text>
        <text x={30} y={263} fontSize="9" fill="#333">Boost:      V_out = V_in / (1−D)   — step up; D=0.4 → V_out = 1.67×V_in</text>
        <text x={30} y={277} fontSize="9" fill="#333">Buck-Boost: V_out = −V_in·D/(1−D) — invert + step up or down</text>
        <text x={30} y={291} fontSize="9" fill="#333">Flyback:    V_out = V_in·(N_s/N_p)·D/(1−D)  — isolated, transformer-coupled</text>
      </svg>
      <div style={S.dCaption}>The buck converter is the archetypal PWM power converter. Adjusting D in real-time (via a voltage-feedback loop) regulates V_out despite varying load or V_in.</div>
    </div>
  );
}

// ── Diagram 6: Dead-Time & Shoot-Through ─────────────────────────────
function DiagramDeadTime() {
  const W = 900, H = 280;
  const sx = 60, T = 220, D = 0.55;
  const Vhi = 20, Vlo = 60, gap = 18;

  const rows = [
    { label:'PWM_H\n(ideal)', color:'#d4a000', yBase: 30,  d: D,   invert: false },
    { label:'PWM_L\n(ideal)', color:'#b88000', yBase: 100, d: 1-D, invert: true  },
    { label:'Q_H gate\n(with DT)', color:'#d4a000', yBase: 170, d: D,   invert: false, dt: 18 },
    { label:'Q_L gate\n(with DT)', color:'#b88000', yBase: 228, d: 1-D, invert: true,  dt: 18 },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Dead-Time Insertion — Ideal vs Actual Gate Signals, Shoot-Through Prevention</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aDT" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#e07b00"/>
          </marker>
        </defs>

        {rows.map((r, ri) => {
          const onW  = r.invert ? (1-D)*T : D*T;
          const offW = T - onW;
          const dt   = r.dt || 0;
          const yHi  = r.yBase;
          const yLo  = r.yBase + gap;
          const x0   = sx;
          const x1   = r.invert ? sx + D*T : sx;       // start of ON
          const x2   = x1 + onW;                        // end of ON

          const x1dt = r.invert ? x1 + dt : x1;        // delayed rising edge
          const x2dt = r.invert ? x2 : x2 - dt;        // advanced falling edge

          return (
            <g key={ri}>
              {/* Row label */}
              {r.label.split('\n').map((l,li)=>(
                <text key={li} x={sx-6} y={yLo-4+li*12} textAnchor="end" fontSize="9"
                  fontWeight="700" fill={r.color}>{l}</text>
              ))}

              {/* Waveform */}
              {r.dt ? (
                // With dead-time: delayed ON, advanced OFF
                <path d={`M ${x0},${yLo} L ${x1dt},${yLo} L ${x1dt},${yHi} L ${x2dt},${yHi} L ${x2dt},${yLo} L ${x0+T},${yLo}`}
                  fill="none" stroke={r.color} strokeWidth="2.5"/>
              ) : (
                // Ideal
                <path d={`M ${x0},${yLo} L ${x1},${yLo} L ${x1},${yHi} L ${x2},${yHi} L ${x2},${yLo} L ${x0+T},${yLo}`}
                  fill="none" stroke={r.color} strokeWidth="2.5" strokeDasharray="6,2"/>
              )}

              {/* Dead-time shading */}
              {r.dt && !r.invert && (
                <rect x={x2dt} y={yHi-2} width={dt} height={gap+4} fill="#e07b00" opacity="0.18" rx={2}/>
              )}
              {r.dt && r.invert && (
                <rect x={x1-dt} y={yHi-2} width={dt} height={gap+4} fill="#e07b00" opacity="0.18" rx={2}/>
              )}
            </g>
          );
        })}

        {/* Dead-time annotation arrows */}
        <line x1={sx+D*T-18} y1={254} x2={sx+D*T} y2={254} stroke="#e07b00" strokeWidth="1.5" markerEnd="url(#aDT)"/>
        <text x={sx+D*T-9} y={268} textAnchor="middle" fontSize="8" fill="#e07b00">t_dead</text>

        {/* Shoot-through zone on ideal (show overlap) */}
        <rect x={sx+D*T-2} y={28} width={4} height={52} fill="#a03000" opacity="0.25" rx={1}/>
        <text x={sx+D*T+10} y={56} fontSize="8" fill="#a03000" fontWeight="700">⚠ overlap</text>
        <text x={sx+D*T+10} y={67} fontSize="8" fill="#a03000">in ideal</text>

        {/* Right panel */}
        <rect x={320} y={18} width={565} height={246} rx={6} fill="#fffbe6" stroke="#d4a000"/>
        <text x={602} y={38} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a4f00">Dead-Time Effects & Trade-offs</text>

        {[
          { t:'Shoot-through', b:'If both Q_H and Q_L are ON simultaneously: V_dc short-circuit\nPeak current only limited by parasitic inductance → catastrophic\nFast (~ns) — must be prevented in hardware, not just software', c:'#a03000' },
          { t:'Dead-time value', b:'Typical: 50 ns (GaN) to 2 µs (IGBT high-voltage)\nSet by: switch fall time + driver propagation delay + margin\nLonger dead-time → safer, but causes waveform distortion', c:'#e07b00' },
          { t:'Dead-time distortion', b:'Output voltage error: ΔV = ±t_dead × V_dc × f_pwm\nError is proportional to f_pwm — important at high frequency\nCompensation: measure dead-time and add corrective duty-cycle offset', c:'#b88000' },
          { t:'Body diode conduction', b:'During dead-time: inductor current flows through body diode\nBody diode V_f ≈ 0.7V → extra loss P = V_f × I × 2 × t_dead × f_pwm\nSynchronous rectification (active SW) replaces diode after dead-time', c:'#d4a000' },
        ].map((item, i) => {
          const y0 = 52 + i*48;
          return (
            <g key={i}>
              <text x={330} y={y0} fontSize="9" fontWeight="700" fill={item.c}>{item.t}:</text>
              {item.b.split('\n').map((l,li)=>(
                <text key={li} x={330} y={y0+12+li*12} fontSize="8" fill="#333">{l}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Dead-time is mandatory for any complementary switch pair. Hardware gate-driver ICs insert it automatically with programmable delay registers.</div>
    </div>
  );
}

// ── Diagram 7: PWM Generation Methods ────────────────────────────────
function DiagramGenMethods() {
  const W = 900, H = 340;
  const labelW = 70, colW = 158, gap = 4;

  const methods = [
    { name:'Analogue\nComparator',  color:'#d4a000' },
    { name:'Timer\nHardware\n(MCU)',color:'#b88000' },
    { name:'Software\nbit-bang',    color:'#c49000' },
    { name:'Dedicated\nPWM IC',     color:'#e07b00' },
    { name:'FPGA /\nPLD',           color:'#b88000' },
  ].map((m, i) => ({ ...m, x: labelW + gap + i*(colW+gap), w: colW }));

  const props = ['Resolution','Frequency','Jitter','Dead-time','CPU load','Cost'];
  const data = [
    ['8–12 bit','1Hz–MHz','Low (HW)','External','Zero','Low'],
    ['8–16 bit','DC–200MHz','Very low','HW reg','Zero','Included'],
    ['Variable','0–~100kHz','High','SW delay','HIGH','Included'],
    ['8–16 bit','DC–1MHz','Very low','HW reg','Zero','Medium'],
    ['1–32 bit','1Hz–500MHz','Minimal','HW logic','Zero','Medium'],
  ];
  const notes = [
    'LM393 comparator\n+ sawtooth osc.',
    'STM32 TIM1\nCCR + ARR regs',
    'GPIO toggle in ISR\nonly for low f_pwm',
    'SG3525 / TL494\nbuilt-in ctrl loop',
    'Xilinx / Intel\n500 MHz clock',
  ];

  const headerH = 64, rowH = 30, startY = headerH + 8;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>PWM Generation Methods — Analogue, Timer, Software, Dedicated IC, FPGA</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Column headers */}
        {methods.map((m, i) => {
          const lines = m.name.split('\n');
          return (
            <g key={i}>
              <rect x={m.x} y={4} width={m.w} height={headerH} rx={7} fill={m.color} opacity="0.9"/>
              {lines.map((l, li) => (
                <text key={li} x={m.x+m.w/2} y={22+li*16} textAnchor="middle"
                  fontSize="11" fontWeight="700" fill="#fff">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Row labels — full labelW, text truncates naturally */}
        {props.map((p, pi) => (
          <g key={pi}>
            <rect x={0} y={startY+pi*rowH} width={labelW} height={rowH-2} rx={2}
              fill={pi%2===0?'#fffbe6':'#fff4cc'}/>
            <text x={4} y={startY+pi*rowH+rowH/2+4} fontSize="9" fontWeight="700" fill="#7a4f00">{p}</text>
          </g>
        ))}

        {/* Data cells */}
        {methods.map((m, mi) =>
          props.map((p, pi) => (
            <g key={`${mi}-${pi}`}>
              <rect x={m.x} y={startY+pi*rowH} width={m.w} height={rowH-2} rx={2}
                fill={pi%2===0?'#fffcf0':'#fffde8'} stroke="#e8c84a" strokeWidth="0.4"/>
              <text x={m.x+m.w/2} y={startY+pi*rowH+rowH/2+4} textAnchor="middle"
                fontSize="9" fill="#1a1200" fontFamily="'Courier New',monospace">{data[mi][pi]}</text>
            </g>
          ))
        )}

        {/* Notes strip — clearly below data */}
        <rect x={0} y={startY+props.length*rowH+6} width={W} height={48} rx={3} fill="#fffbe6"/>
        {methods.map((m, i) =>
          notes[i].split('\n').map((l, li) => (
            <text key={`${i}-${li}`}
              x={m.x + m.w/2}
              y={startY+props.length*rowH+22+li*16}
              textAnchor="middle" fontSize="8" fill="#666">{l}</text>
          ))
        )}
      </svg>
      <div style={S.dCaption}>Hardware-based PWM (timer or dedicated IC) is always preferred — zero CPU overhead, deterministic timing, and hardware dead-time insertion.</div>
    </div>
  );
}

// ── Diagram 8: Three-Phase SVPWM Space Vector ────────────────────────
function DiagramSVPWM() {
  const W = 900, H = 330;
  // Hexagon centred at cx,cy with radius r — kept compact on left half
  const cx = 220, cy = 168, r = 112;

  const vectors = arr(6).map(i => {
    const angle = i * 60 * Math.PI / 180;
    return {
      x: cx + r * Math.cos(angle),
      y: cy - r * Math.sin(angle),
      label: `V${i+1}`,
    };
  });

  // Right panel starts well clear of hexagon right edge (cx+r ≈ 332)
  const panelX = 358, panelW = 900 - panelX - 8;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Space Vector PWM (SVPWM) — Hexagonal Voltage Space, Sectors, and Zero Vectors</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aSV" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
        </defs>

        {/* Hexagon */}
        <polygon points={vectors.map(v=>`${v.x},${v.y}`).join(' ')}
          fill="none" stroke="#e8c84a" strokeWidth="1.5" strokeDasharray="6,3"/>

        {/* Inner inscribed circle (SPWM limit) */}
        <circle cx={cx} cy={cy} r={r*Math.sqrt(3)/2} fill="none"
          stroke="#b88000" strokeWidth="1.2" strokeDasharray="4,4"/>

        {/* SPWM label — below centre so it doesn't clash */}
        <text x={cx} y={cy+r*Math.sqrt(3)/2+14} textAnchor="middle" fontSize="8" fill="#b88000">SPWM M=0.866</text>

        {/* Outer circle (SVPWM limit) */}
        <circle cx={cx} cy={cy} r={r} fill="none"
          stroke="#d4a000" strokeWidth="1.2" strokeDasharray="4,4"/>
        <text x={cx} y={cy-r-6} textAnchor="middle" fontSize="8" fill="#d4a000">SVPWM M=1.0</text>

        {/* Active voltage vectors */}
        {vectors.map((v, i) => (
          <g key={i}>
            <line x1={cx} y1={cy} x2={v.x} y2={v.y}
              stroke="#d4a000" strokeWidth="2.5" markerEnd="url(#aSV)"/>
            <rect x={v.x-14} y={v.y-10} width={28} height={18} rx={3} fill="#d4a000" opacity="0.92"/>
            <text x={v.x} y={v.y+4} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff">{v.label}</text>
          </g>
        ))}

        {/* Zero vectors at centre */}
        <circle cx={cx} cy={cy} r={14} fill="#b88000" opacity="0.9"/>
        <text x={cx} y={cy-2} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fff">V0</text>
        <text x={cx} y={cy+9} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fff">V7</text>

        {/* Sector labels */}
        {arr(6).map(i => {
          const angle = (i*60 + 30) * Math.PI / 180;
          const lr = r * 0.52;
          return (
            <text key={i} x={cx+lr*Math.cos(angle)} y={cy-lr*Math.sin(angle)+4}
              textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a4f00">S{i+1}</text>
          );
        })}

        {/* Reference vector Vref */}
        {(() => {
          const ang = 25 * Math.PI / 180;
          const mag = r * 0.70;
          return (
            <g>
              <line x1={cx} y1={cy} x2={cx+mag*Math.cos(ang)} y2={cy-mag*Math.sin(ang)}
                stroke="#e07b00" strokeWidth="3" markerEnd="url(#aSV)"/>
              <text x={cx+mag*Math.cos(ang)+6} y={cy-mag*Math.sin(ang)-4}
                fontSize="10" fontWeight="700" fill="#e07b00">V_ref</text>
              <text x={cx+mag*Math.cos(ang)+6} y={cy-mag*Math.sin(ang)+9}
                fontSize="8" fill="#e07b00">(desired)</text>
            </g>
          );
        })()}

        {/* T1·V1, T2·V2 decomposition */}
        {(() => {
          const ang = 25 * Math.PI / 180;
          const mag = r * 0.70;
          const v1x = vectors[0].x, v1y = vectors[0].y;
          const t1 = 0.52;
          const tip = { x: cx+mag*Math.cos(ang), y: cy-mag*Math.sin(ang) };
          return (
            <g>
              <line x1={cx} y1={cy} x2={cx+t1*(v1x-cx)} y2={cy+t1*(v1y-cy)}
                stroke="#d4a000" strokeWidth="1.5" strokeDasharray="4,2" opacity="0.6"/>
              <line x1={cx+t1*(v1x-cx)} y1={cy+t1*(v1y-cy)} x2={tip.x} y2={tip.y}
                stroke="#b88000" strokeWidth="1.5" strokeDasharray="4,2" opacity="0.6"/>
              <text x={cx+t1*(v1x-cx)/2} y={cy+t1*(v1y-cy)/2+13} fontSize="8" fill="#d4a000">T1·V1</text>
              <text x={cx+t1*(v1x-cx)+(tip.x-cx-t1*(v1x-cx))/2}
                y={cy+t1*(v1y-cy)+(tip.y-cy-t1*(v1y-cy))/2+13}
                fontSize="8" fill="#b88000">T2·V2</text>
            </g>
          );
        })()}

        {/* Right panel — starts at panelX, width panelW, ends at W-8 */}
        <rect x={panelX} y={8} width={panelW} height={H-16} rx={6} fill="#fffbe6" stroke="#d4a000"/>
        <text x={panelX+panelW/2} y={28} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a4f00">SVPWM Key Concepts</text>

        {[
          { t:'8 switching states',      b:'6 active: V1(100)–V6(101) at 60° intervals\n2 zero: V0(000)=off, V7(111)=all-on\nEach → different voltage vector magnitude + direction' },
          { t:'Reference vector V_ref',  b:'Desired output voltage as a rotating phasor\nRotates at ω_e (electrical frequency) once per cycle\nMagnitude = modulation index M (0 to 1)' },
          { t:'Sector identification',   b:'θ = atan2(V_β, V_α) → which of 6 sectors\nT1, T2 = times of two adjacent active vectors\nT0 = T_pwm − T1 − T2 (zero vector time)' },
          { t:'Dwell time calculation',  b:'T1 = T·M·sin(60°−θ_sec)/sin(60°)\nT2 = T·M·sin(θ_sec)/sin(60°)\nZero split: T0/2 as V0 and V0/2 as V7' },
          { t:'15% more V_out vs SPWM', b:'SPWM max M = √3/2 ≈ 0.866 (inscribed circle)\nSVPWM max M = 1.0 (hexagon vertex)\nSame DC bus → 15.5% higher motor voltage' },
          { t:'Sequence optimisation',   b:'DPWM: one phase clamped each 60° sector\nReduces switching loss 33% vs continuous SVPWM\nIncreases output harmonics — trade-off' },
        ].map((item, i) => {
          const y0 = 46 + i*46;
          return (
            <g key={i}>
              <text x={panelX+8} y={y0} fontSize="9" fontWeight="700" fill="#b88000">{item.t}:</text>
              {item.b.split('\n').map((l, li) => (
                <text key={li} x={panelX+8} y={y0+12+li*12} fontSize="8" fill="#333">{l}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>SVPWM is the standard algorithm in FOC motor drives. It maximises DC bus utilisation and allows precise, low-harmonic three-phase voltage synthesis.</div>
    </div>
  );
}

// ── Diagram 9: PWM Applications Overview ────────────────────────────
function DiagramApplications() {
  const W = 900, H = 280;
  const apps = [
    { name:'DC Motor\nSpeed Control', sub:'H-Bridge\n1–100 kHz', color:'#d4a000', x:30  },
    { name:'SMPS\n(Buck/Boost)', sub:'CC/CV feedback\n100kHz–2MHz', color:'#e07b00', x:200 },
    { name:'LED\nDimming', sub:'Flicker-free\n1–50 kHz', color:'#b88000', x:370 },
    { name:'Servo\nSignal', sub:'50Hz, 1–2ms\nRC hobby', color:'#c49000', x:540 },
    { name:'Audio\nClass-D Amp', sub:'250–500 kHz\nΣΔ modulated', color:'#d4a000', x:710 },
  ];

  const bottom = [
    { name:'AC Inverter\n(VFD/UPS)', sub:'3-phase SVPWM\n2–20 kHz', color:'#b88000', x:30  },
    { name:'Solar MPPT\nInverter', sub:'Grid-tied\nUnipolar SPWM', color:'#d4a000', x:200 },
    { name:'Wireless\nCharging', sub:'6.78 MHz ISM\nClass-E resonant', color:'#e07b00', x:370 },
    { name:'Solenoid\nValve', sub:'24V, variable\nforce control', color:'#c49000', x:540 },
    { name:'Heating\nElement', sub:'Phase-angle or\nzero-cross burst', color:'#b88000', x:710 },
  ];

  const BOX_W = 150, BOX_H = 72;

  const renderRow = (items, yTop) => items.map((a, i) => {
    const lines = a.name.split('\n');
    const subs  = a.sub.split('\n');
    return (
      <g key={i}>
        <rect x={a.x} y={yTop} width={BOX_W} height={BOX_H} rx={7} fill={a.color} opacity="0.88"/>
        {lines.map((l,li)=>(
          <text key={li} x={a.x+BOX_W/2} y={yTop+22+li*16} textAnchor="middle"
            fontSize="11" fontWeight="700" fill="#fff">{l}</text>
        ))}
        {subs.map((l,li)=>(
          <text key={li} x={a.x+BOX_W/2} y={yTop+55+li*12} textAnchor="middle"
            fontSize="8" fill="#fff9cc">{l}</text>
        ))}
      </g>
    );
  });

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>PWM Applications Across Electrical Engineering</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <text x={W/2} y={16} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a4f00">Power & Motion Control</text>
        {renderRow(apps, 22)}
        <text x={W/2} y={114} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a4f00">Conversion, Signal & Thermal</text>
        {renderRow(bottom, 122)}

        {/* Centre PWM label */}
        <rect x={360} y={200} width={180} height={68} rx={8} fill="#d4a000" opacity="0.95"/>
        <text x={450} y={223} textAnchor="middle" fontSize="14" fontWeight="700" fill="#fff">PWM</text>
        <text x={450} y={240} textAnchor="middle" fontSize="10" fill="#fff9cc">Pulse Width</text>
        <text x={450} y={254} textAnchor="middle" fontSize="10" fill="#fff9cc">Modulation</text>
        <text x={450} y={268} textAnchor="middle" fontSize="9" fill="#fff9cc">universal control method</text>
      </svg>
      <div style={S.dCaption}>PWM appears in virtually every area of power electronics and embedded systems — the duty cycle is the universal control knob.</div>
    </div>
  );
}

// ── Main Export ──────────────────────────────────────────────────────
export default function PWMControl() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>PWM — Pulse Width Modulation: Complete Engineering Reference</h1>
      <p style={S.p}>
        Pulse Width Modulation is the ubiquitous technique of encoding a desired analogue level into
        the <em>duty cycle</em> of a fixed-frequency digital switching signal. A switch alternates
        between fully ON and fully OFF at high frequency; the fraction of time it spends ON linearly
        sets the average power or voltage delivered to the load. Because real switches are either
        fully ON (low V_drop) or fully OFF (zero current), switching losses are far lower than
        linear regulation — making PWM the foundation of efficient power electronics.
      </p>

      <InfoBox title="PWM at a Glance" items={[
        "Definition: D = t_on / T  →  V_avg = D × V_supply  (D from 0 to 1)",
        "Frequency range: 50 Hz (servo) · 10–100 kHz (motor/SMPS) · 250 kHz–2 MHz (GaN/SiC)",
        "Resolution: 8-bit (256 steps) to 20-bit (1M steps) depending on timer clock and period",
        "Current ripple: ΔI = V_dc × D × (1−D) / (L × f_pwm)  — worst at D = 50%",
        "Switching loss: P_sw = ½ × V_ds × I_d × (t_r + t_f) × f_pwm  — scales linearly with f",
        "Complementary PWM: high and low side signals are inverted with mandatory dead-time gap",
        "Centre-aligned PWM halves ripple vs edge-aligned at identical f_pwm and switching loss",
        "SVPWM achieves 15% higher fundamental output than SPWM for same DC bus voltage",
        "Applications: DC/BLDC motors, buck/boost/flyback converters, LED dimming, class-D audio, servo, VFD",
      ]}/>

      <h2 style={S.h2}>PWM Anatomy — The Fundamental Signal</h2>
      <p style={S.p}>
        A PWM signal is a square wave with fixed frequency and variable ON-time. Three parameters
        completely define it: the supply voltage V_high, the period T (= 1/f_pwm), and the duty cycle
        D. The load's natural inertia or an LC filter converts this switching waveform into a nearly
        smooth average value of D × V_high.
      </p>
      <DiagramAnatomy/>
      <Table2 rows={[
        ["Period T & frequency f","T = 1/f_pwm.  Higher f → smaller T → faster response, less ripple, more switching loss\nCommon values: servo=20ms (50Hz), motor=50µs (20kHz), SMPS=2µs (500kHz)"],
        ["Duty cycle D","D = t_on / T.  Range: 0% (always off) to 100% (always on)\nV_avg = D × V_high  — perfectly linear: the key advantage of PWM control"],
        ["Rise and fall time","Finite transition time caused by gate capacitance charging through gate resistance\nt_r, t_f typically 10–200 ns. During transition: both V_ds and I_d are non-zero → loss"],
        ["PWM resolution","N-bit resolution: 2^N steps from 0% to 100%\nA 16-bit, 20 MHz clock timer gives f_pwm = 20MHz/65536 = 305 Hz\nHigher f_pwm with same clock → fewer counts → lower resolution"],
        ["Timer counter modes","Up-counting: ARR register sets period; CCR sets duty; edge-aligned output\nUp-down counting: triangle wave; centre-aligned output; ARR sets half-period\nPhase-correct: centre-aligned; double-edge update; common in motor controllers"],
        ["Soft start","Ramp D from 0 to target over multiple cycles on startup\nLimits inrush current; prevents voltage spikes on capacitive loads\nEssential in SMPS and motor controllers to avoid overcurrent trip"],
        ["Minimum on/off time","Practical minimum: t_dead + driver propagation delay + ADC sampling window\nBelow minimum: duty resolution collapses; waveform distorts significantly\nUsually 200–500 ns minimum pulse for modern gate drivers"],
      ]}/>

      <h2 style={S.h2}>Edge-Aligned vs Centre-Aligned PWM</h2>
      <p style={S.p}>
        The shape of the carrier waveform — sawtooth (edge-aligned) or triangle (centre-aligned) —
        determines the symmetry of the output pulses, their harmonic content, and how easily
        current measurements can be synchronised to the PWM cycle.
      </p>
      <DiagramAlignment/>
      <Table2 rows={[
        ["Edge-aligned (up-count)","Timer counts 0→ARR, resets. Compare match at CCR sets edge.\nAll pulses start at t=0; all falling edges at t=D×T\nADC must sample away from both edges — often in middle of ON or OFF time"],
        ["Centre-aligned (up-down)","Timer counts 0→ARR→0. Two compare matches per period.\nPulse centred in period; symmetrical about midpoint\nADC triggered at counter underflow (t=0) — minimum switching noise at sample point"],
        ["Ripple advantage","Centre-aligned: inductor sees double the effective frequency\nΔI_centre = ΔI_edge / 2  for same L, f_pwm, and D\nAllows smaller L for same ripple, or lower f_pwm for same ripple"],
        ["EMI advantage","Centre-aligned: two smaller current steps vs one large step per period\nReduced dI/dt magnitude → lower radiated EMI\nHarmonics at 2n×f_pwm instead of n×f_pwm — higher and easier to filter"],
        ["Multi-channel synchronisation","Centre-aligned allows interleaving multiple phases at same carrier\n3-phase motor: all 3 timer channels share one up-down counter → synchronised\nCritical: gate signals must be synchronised to prevent bus capacitor resonance"],
        ["Phase shift (interleaved)","Two converters at 180° phase: effective ripple at 2×f_pwm to input capacitor\nN interleaved: ripple at N×f_pwm; capacitor size reduces by 1/N²\nUsed in multiphase VRMs (CPU power), high-current battery chargers"],
      ]}/>

      <h2 style={S.h2}>Duty Cycle, Average Voltage, and Current Ripple</h2>
      <DiagramDutySweep/>
      <Table2 rows={[
        ["Average output voltage","V_avg = D × V_dc  (ideal, resistive load)\nFor inductive load (motor, inductor): V_avg drives steady-state current; ripple is separate\nValid for any topology in CCM (Continuous Conduction Mode)"],
        ["Inductor current ripple","ΔI_L = V_dc·D·(1−D) / (L·f_pwm)\nMaximum at D=0.5: ΔI_max = V_dc / (4·L·f_pwm)\nRipple is load-current-independent — set by L, f, V_dc, D only"],
        ["Output voltage ripple","ΔV_C = ΔI_L / (8·C·f_pwm)  (centre-aligned, CCM)\nOr: ΔV_C = I_load/(C·f_pwm) when C dominates\nESR of capacitor often dominates: ΔV_ESR = ΔI_L × ESR"],
        ["Continuous conduction mode","CCM: inductor current never reaches zero; average I_L > ΔI_L/2\nControl gain is constant (no mode-change behaviour)\nPreferred for closed-loop control — simpler transfer function"],
        ["Discontinuous conduction mode","DCM: inductor current falls to zero during OFF time\nOccurs at light load; boundary: I_load < ΔI_L/2\nHigher voltage gain; different small-signal transfer function; easier to control at light load"],
        ["Ripple vs efficiency trade-off","Lower L: cheaper/smaller, more ripple, higher current stress\nHigher f: less ripple, higher switching loss, GaN/SiC justified above 500kHz\nOptimum: choose L such that ripple-to-current ratio ≈ 20–40% of I_avg"],
        ["RMS current stress","I_rms² = I_avg² + (ΔI_L/√12)²  — ripple adds to RMS heating\nCapacitor: I_C_rms = ΔI_L/√12 (approximately) — determines cap temperature rise\nMOSFET: I_rms = I_avg × √(D + ΔI²/(3·I_avg²)) — must be within rating"],
      ]}/>

      <h2 style={S.h2}>Frequency Domain — Harmonics and Filtering</h2>
      <DiagramHarmonics/>
      <Table2 rows={[
        ["PWM Fourier series","v(t) = D·V_dc + Σ [2V_dc/(nπ)·sin(nπD)]·cos(2πnf_pwm·t)\nDC term + infinite series of harmonics at n×f_pwm\nOdd harmonics dominate at D=50% (sin(nπ/2)=±1 for odd n)"],
        ["Filter design goal","Attenuate all harmonics by required amount; pass DC (and audio/control signal)\nSimple LC: f_corner = 1/(2π√(LC)). Roll-off: −40 dB/decade above f_corner\nRequirement: 20×log10(ΔV_allowed/V_harmonic_1) dB attenuation needed"],
        ["LC low-pass filter","L and C form 2nd-order filter: f_c = 1/(2π√LC)\nDamping ratio: ζ = R/(2√(L/C)); R is load resistance\nUnderdamped (ζ<0.5): peaking near f_c; overdamped: sluggish response"],
        ["RC filter","1st order: f_c = 1/(2πRC); only −20 dB/decade rolloff\nSimple but lossy — R dissipates power; not suitable for power-stage filtering\nUseful for: servo command signal, analogue reference, low-power DAC output"],
        ["EMI and harmonics","Harmonics radiate as common-mode and differential-mode EMI\nMIL-STD-461, CISPR 25, IEC 61000-4: define conducted/radiated emission limits\nMitigation: EMI filter (common-mode choke + X/Y caps), shielding, spread-spectrum PWM"],
        ["Spread-spectrum PWM","Randomise or dither f_pwm ±5% each period\nSpreads harmonic energy over wider bandwidth → reduces peak spectral amplitude\nReduces audible tones and helps pass EMI tests; slight increase in average ripple"],
        ["Nyquist and sampling","Control loop samples PWM output at f_s; must have f_s > 2×f_signal\nPWM itself is not band-limited — aliasing of harmonics is prevented by LC filter\nADC sample must be timed to midpoint of PWM period to avoid switching transients"],
        ["Switching frequency harmonics","PWM harmonic amplitude: |a_n| = (2V_dc)/(nπ) × |sin(nπD)|\nHigher f_pwm pushes harmonics higher in frequency → smaller filter components\nAt 1 MHz: 2nd harmonic at 2 MHz — small ceramic caps easily filter it"],
      ]}/>

      <h2 style={S.h2}>PWM in DC-DC Power Converters</h2>
      <p style={S.p}>
        The bucket converter's duty cycle is the direct handle on output voltage. PWM control, combined with an
        output voltage feedback loop (compensator), regulates V_out against varying load and input. The same
        principle extends to boost, buck-boost, flyback, and full-bridge topologies.
      </p>
      <DiagramBuck/>
      <Table2 rows={[
        ["Buck converter","V_out = D × V_in  (CCM ideal)\nEfficiency: η = P_out/P_in — limited by R_ds_on, switching loss, inductor DCR\nControl: voltage-mode or current-mode; type-II or type-III compensator for phase margin"],
        ["Boost converter","V_out = V_in / (1−D)  (CCM ideal)\nGain → ∞ as D→1 (never reach D=1 — current limit required)\nRHP zero in control loop: limits achievable bandwidth to ~f_pwm/20"],
        ["Buck-boost (inverting)","V_out = −V_in × D/(1−D)  (inverts polarity)\nUsed in: battery chargers (must charge above and below V_batt)\nFour-switch non-inverting buck-boost avoids polarity flip"],
        ["Flyback converter","V_out = V_in × (N_s/N_p) × D/(1−D)  (DCM)\nIsolated: primary and secondary galvanically separated by transformer\nSingle switch; energy stored in transformer gap — popular in off-line SMPS"],
        ["Full-bridge / phase-shift","V_out ∝ phase shift between two H-bridge legs; ZVS achievable\nUsed in: high-power isolated DC-DC (server PSU, EV charger, telecom)\nPhase-shift control instead of duty cycle — natural ZVS soft switching"],
        ["Voltage-mode control","PWM duty cycle commanded by error amplifier output directly\nSimple; needs type-II/III compensator for adequate phase margin\nSlow response to load transients — compensator must have wide bandwidth"],
        ["Current-mode control","Inner current loop: inductor current directly commanded each cycle\nOuter voltage loop sets current reference\nAutomatic current limiting; better transient response; slope compensation needed for D>0.5"],
        ["Small-signal model","Averaged model: switch replaced by controlled voltage/current source\nTransfer functions: G_vd(s) (control-to-output), G_vg(s) (input-to-output)\nBode plot used to design compensator: target: >45° phase margin, >10 dB gain margin"],
      ]}/>

      <h2 style={S.h2}>Dead-Time and Complementary Switching</h2>
      <p style={S.p}>
        Any system with complementary switch pairs — H-bridges, half-bridges, three-phase inverters —
        must prevent both switches in a leg from conducting simultaneously. A tiny overlap in gate
        drive signals creates a direct short across the DC bus (shoot-through). Dead-time is the
        mandatory blanking interval between turning one switch OFF and the other ON.
      </p>
      <DiagramDeadTime/>
      <Table2 rows={[
        ["Minimum dead-time","t_dead ≥ t_fall(Q_off) + t_rise(Q_on) + t_propagation_mismatch + safety_margin\nSi MOSFET: 100–500 ns; IGBT: 1–3 µs; GaN: 20–100 ns; SiC: 100–300 ns\nMismatch between high-side and low-side driver delays must be included"],
        ["Dead-time distortion","ΔV_error = ±t_dead × V_dc × f_pwm per phase (sign depends on current direction)\nAt 500kHz with 200ns dead-time and 48V: ΔV = 200e-9 × 48 × 500e3 = 4.8V error\nDeadtime compensation: measure current direction, add/subtract correction to duty cycle"],
        ["Body diode conduction","During dead-time, inductor current must flow — body diode conducts\nV_f ≈ 0.7V (Si) or 1.5–2V (GaN body diode) — energy dissipated as heat\nSynchronous rectification: turn on the switch after dead-time; current flows through R_ds_on<<V_f"],
        ["Zero-voltage switching (ZVS)","During dead-time, parasitic capacitance (C_oss) resonates with inductor\nIf resonance brings V_ds → 0 before gate is applied: turn-on at zero voltage\nZVS eliminates C_oss switching loss: ΔE = ½·C_oss·V_ds² saved per cycle"],
        ["Adaptive dead-time","Monitor drain voltage of next switch to turn ON\nWait until V_ds < threshold (e.g. 20V) before asserting gate signal\nMaximises ZVS while minimising dead-time distortion — requires fast comparator"],
        ["Gate drive IC dead-time","Most gate driver ICs offer programmable dead-time via resistor or register\nIR2110: internal DT set by bootstrap capacitor; limited programmability\nUCC27211: external resistor sets DT 25ns–500ns; tight matching\nSTM32 TIM1: BDTR register; 8-bit resolution; DEAD = t_ck × DTG value"],
      ]}/>

      <h2 style={S.h2}>PWM Generation Methods</h2>
      <DiagramGenMethods/>
      <Table2 rows={[
        ["MCU hardware timer","STM32 TIM1: 16-bit advanced control timer; centre-aligned + complementary outputs\nRegisters: ARR (period), CCR (compare/duty), BDTR (dead-time, break input)\nUpdate event: duty updated at end of period (shadow register) → glitch-free\nDMA burst: update CCR for waveform generation without CPU intervention"],
        ["DMA waveform generation","Precompute array of CCR values; DMA copies to timer on each update event\nAllows arbitrary waveform synthesis: SPWM, SVPWM lookup table, arbitrary profiles\nCPU completely free during generation; minimal jitter (DMA has fixed latency)"],
        ["Analogue PWM (comparator)","Sawtooth from integrator + comparator: V_out = HIGH when V_ref > V_ramp\nSG3525/UC3842: integrated SMPS controller with comparator, oscillator, driver\nVery low latency (<100ns) — useful for current-mode control inner loop"],
        ["FPGA implementation","Counter + comparator in LUT logic: 1-bit resolution per LUT level\n32-bit counter at 500MHz: f_pwm = 500MHz/65536 ≈ 7.6kHz; or higher res/lower f\nFully deterministic; no interrupt latency; multiple channels share one clock domain"],
        ["Sigma-delta PWM","Oversampled 1-bit DAC; noise-shaping pushes quantisation noise to high frequency\nRequires high oversampling ratio (64×–256×) and aggressive low-pass filter\nUsed in: class-D audio amplifiers, high-resolution analogue output (24-bit audio)"],
        ["Resolution vs frequency trade-off","With f_clk = 168 MHz (STM32): f_pwm = f_clk / (ARR+1)\n8-bit (255 counts): f_pwm = 659 kHz;  16-bit (65535): f_pwm = 2.6 kHz\nHigh-resolution timer (HRTIM): 184 ps step on STM32H7 → 14-bit at 500 kHz"],
        ["Synchronisation between channels","Phase relationship critical in 3-phase inverter and interleaved converters\nAll timers must share a common clock and start event\nSTM32: master timer triggers slave timers; HRTIM: sub-nanosecond sync\nJitter budget: for 1% duty error at 50 kHz, need timing accuracy < 200 ns"],
        ["Test and measurement","Oscilloscope: measure t_on, T, dead-time at gate (×10 probe, 200MHz+)\nLogic analyser: verify duty cycle, frequency, dead-time insertion\nCurrent probe on inductor: verify ΔI matches calculation at given D and f_pwm"],
      ]}/>

      <h2 style={S.h2}>Three-Phase SVPWM</h2>
      <p style={S.p}>
        Space Vector PWM (SVPWM) is the standard algorithm for driving three-phase inverters in
        motor control and grid-connected converters. Rather than treating each phase independently,
        it synthesises the desired output as a vector rotating in a 2D plane, selecting the two
        nearest active voltage vectors and splitting the remaining time between zero vectors.
      </p>
      <DiagramSVPWM/>
      <Table2 rows={[
        ["Eight switch states","Six active vectors: V1(100), V2(110), V3(010), V4(011), V5(001), V6(101)\nTwo zero vectors: V0(000) — all low-sides ON; V7(111) — all high-sides ON\nBit notation: 1 = high-side ON, 0 = low-side ON for phases U,V,W respectively"],
        ["Voltage vector magnitudes","All active vectors: |V_k| = (2/3)·V_dc (line-to-neutral equivalent)\nZero vectors: magnitude = 0 (no net voltage applied to motor)\nReference V_ref traces a circle; radius ≤ |V_k| for linear modulation"],
        ["Dwell time calculation","In sector 1 (0° ≤ θ < 60°): T1 = T·√3·M·sin(60°−θ),  T2 = T·√3·M·sin(θ)\nT0 = T − T1 − T2 (shared equally between V0 and V7)\nM = modulation index = |V_ref| / (V_dc/√3), range 0 to 1"],
        ["Switching sequence","Symmetric sequence in sector 1: V0, V1, V2, V7, V2, V1, V0\nEach half-period: only one phase changes state → minimal switching transitions\n4 switch events per half-period → 8 per full period for all 3 phases"],
        ["Discontinuous PWM (DPWM)","One phase clamped to +bus or −bus for 60° per sector (no switching)\nEliminates 2 switch events per period → saves 33% switching loss\nIncreases output harmonics; used when thermal constraint is critical"],
        ["Over-modulation","M > 1: reference exits hexagon boundary; some dwell times go negative\nClamped to 0 → modulation becomes non-linear; THD increases\nFull square-wave (6-step) reached at M = 1.27; maximum fundamental output"],
        ["Neutral point voltage injection","SVPWM injects 3rd harmonic into phase references automatically\nPhase voltage has 3rd harmonic; line-to-line voltage is pure sinusoidal\n3rd harmonic injection = equivalent transformation to SVPWM from per-phase view"],
        ["Implementation steps","1. V_ref → (V_α, V_β) via reference frame\n2. Determine sector: θ = atan2(V_β, V_α) / 60°\n3. Calculate T1, T2, T0 for that sector\n4. Assign dwell times to CCR registers for U, V, W timers"],
      ]}/>

      <h2 style={S.h2}>PWM in Motor Control</h2>
      <Table2 rows={[
        ["Brushed DC motor","Single H-bridge; PWM duty controls average voltage → speed\nBack-EMF provides passive regulation; closed-loop needs tachometer or encoder\nPWM frequency: 10–50 kHz (above audio); current ripple through brush contact"],
        ["BLDC — 6-step commutation","6 switch events per electrical revolution; each phase ON for 120° electrical\nPWM applied to active high-side switch; low-side fully ON\nHall sensors determine commutation angle; BEMF zero-crossing for sensorless"],
        ["PMSM — sinusoidal / FOC","Continuous sinusoidal currents in all three phases simultaneously\nSVPWM updates duty for all 3 phases each PWM period; angle from encoder/resolver\nFOC decouples torque (Iq) and flux (Id); PI loops on DC quantities"],
        ["Current measurement timing","Sample phase current at PWM midpoint: minimum ripple, maximum signal-to-noise\nSTM32: ADC triggered by TIM1_TRGO at counter underflow event\nFor low duty: single shunt may miss current — use 3-shunt or mid-point injection"],
        ["Switching frequency for motors","Too low (<5kHz): audible whine, high torque ripple, poor current loop BW\nToo high (>100kHz): switching loss → thermal derating; gate driver limits\nSweet spot: 20–50kHz for Si; 100–200kHz for SiC/GaN — allows smaller magnetics"],
        ["Voltage distortion compensation","Dead-time, diode drop, V_ds_on cause output voltage error\nCompensation: measure motor current direction; add ΔV_comp = ±t_dead·V_dc·f\nWithout compensation: low-speed torque ripple at 6× electrical frequency"],
        ["Current loop bandwidth","Must complete (sense → FOC → update duty) within one PWM period\nAt 20kHz: 50µs budget for entire ISR including Clarke, Park, PI, SVPWM\nSTM32 Cortex-M4 at 168MHz + FPU: complete FOC cycle in 2–5µs comfortably"],
        ["Flying capacitor / multilevel","3-level NPC inverter: V_dc/2 steps → lower dV/dt, less motor insulation stress\nLower switching losses per device; used in high-voltage (>400V) motor drives\nControl: interleaved carriers per cell; modulation more complex but well-established"],
      ]}/>

      <h2 style={S.h2}>PWM for LED Dimming and Lighting</h2>
      <Table2 rows={[
        ["Why PWM for LEDs","LEDs are current-controlled; efficiency peaks at rated current\nAnalogue dimming (reduce I): shifts colour point — unacceptable in colour-critical applications\nPWM dimming: full current during ON; zero during OFF → colour maintained at any brightness"],
        ["Flicker and perception","Below ~80 Hz: visible flicker — causes headaches, eye strain (IEEE 1789)\n100–1000 Hz: invisible to most humans; sensitive individuals notice to 200 Hz\nAbove 1kHz: universally flicker-free; preferred for office/medical/cinema lighting"],
        ["Minimum pulse width","At 1% brightness with 1kHz PWM: t_on = 10µs\nLED driver response time must be << 10µs; some drivers need 200ns minimum\nVery low duty stretches minimum pulse; use higher f or dedicated PWM LED driver"],
        ["Logarithmic dimming","Human eye: logarithmic (Weber-Fechner law) — equal perceived steps need exponential D\n256 linear D steps perceived as only ~30 distinguishable brightness levels\nSolution: gamma correction table; or 256 logarithmically-spaced D values"],
        ["PWM LED driver ICs","TLC5947: 24-channel, 12-bit PWM, constant current, SPI control\nPCA9685: 16-channel, 12-bit, I²C — popular in robotics, Arduino\nDMX512: entertainment lighting protocol; 250 kbps UART carrying 512 8-bit channels"],
        ["Strobe / synchronisation","High-speed video: LED strobe must sync to camera frame rate to avoid banding\nTrigger PWM from camera sync output; match LED duty to exposure window\nCommon in machine vision, sports photography, endoscopy illumination"],
      ]}/>

      <h2 style={S.h2}>PWM in Audio — Class-D Amplifiers</h2>
      <Table2 rows={[
        ["Class-D principle","Input audio modulates duty cycle of 250–500kHz PWM carrier\nH-bridge output filtered by LC low-pass (f_c ≈ 30–80 kHz) to recover audio\nEfficiency: 90–98% (vs 50–70% class-AB) — no dissipation in output transistors"],
        ["Naturally sampled PWM","Continuous-time comparator: audio waveform vs triangle carrier\nNo sampling delay; low distortion; used in analogue class-D (TPA3116 family)\nDistortion: primarily from deadtime, supply ripple modulating carrier amplitude"],
        ["Uniformly sampled PWM","Discrete: audio sampled at f_s; each sample sets duty for one PWM period\nCauses baseband distortion at high modulation — needs correction or oversampling\nOversampling at 8–16× reduces distortion; standard in digital class-D"],
        ["Sigma-delta modulation","1-bit or multi-bit Σ-Δ converts audio to high-rate bitstream\nNoise-shaped: quantisation noise pushed above 20kHz; 6th-order noise shaping typical\nLP filter recovers audio; used in premium audio DACs (PCM1794, ES9038)"],
        ["Output LC filter","L ≈ 10–47µH; C ≈ 1–10µF (BTL: no cap to GND); f_c = 30–80kHz\nDamping critical: speaker impedance (4–8Ω) provides damping at high f\nUnloaded (no speaker): filter rings; protection circuits detect this"],
        ["THD+N","Total Harmonic Distortion + Noise: < 0.01% achievable in modern class-D\nLimited by: dead-time distortion, power supply rejection, gate charge nonlinearity\nFeedback loop (global NFB) around entire stage reduces distortion 20–40 dB"],
      ]}/>

      <h2 style={S.h2}>PWM Applications Overview</h2>
      <DiagramApplications/>

      <h2 style={S.h2}>Protection, Faults, and Safety</h2>
      <Table2 rows={[
        ["Over-current (OCP)","Hardware comparator trips gate driver within 1 switching cycle (<1µs)\nCycle-by-cycle limiting: reset PWM latch each cycle if I > threshold; no fault latch\nFault latch: after n overcurrent events, disable outputs; require manual reset (EN pin)"],
        ["Shoot-through prevention","Hardware dead-time in gate driver is the primary protection\nCross-conduction lockout: UVLO disables gate drive if V_cc drops (driver IC feature)\nSoftware: never write complementary outputs simultaneously; use hardware timer shadow registers"],
        ["Under-voltage lockout (UVLO)","Gate driver monitors own V_cc; disables outputs below threshold (e.g. 8V for a 12V supply)\nPrevents partially-enhanced gate (high R_ds_on → thermal runaway)\nStart-up: ramp D slowly after UVLO clears; avoid output voltage overshoot"],
        ["Over-temperature","NTC thermistor on heatsink/device; ADC reads every control cycle\nDerate output: reduce I_limit proportionally above T_warn (e.g. 80°C)\nShutdown: disable PWM outputs when T_junction > T_max (e.g. 150°C for Si MOSFET)"],
        ["Output short circuit","Current rises at dI/dt = V_dc/L; must detect before MOSFET exceeds I_sat or I_rated\nDesaturation detection: measure V_ds during ON time; if V_ds > threshold → fault\nRequired gate drive minimum: fast detection must beat dI/dt; faster for lower L"],
        ["EMI / conducted emissions","Differential mode: filter via series L and shunt X-caps across input\nCommon mode: choke (wound on toroid) + Y-caps to chassis ground\nPeak switch dV/dt: 1–50 kV/µs in Si; 100+ kV/µs in GaN → more stringent CM filter"],
        ["PWM enable / disable","Gate driver EN or INHIBIT pin: hardware disables all outputs synchronously\nSafe state: both switches OFF (high-impedance), freewheeling diodes clamp\nSTO (Safe Torque Off): two independent disable paths; SIL2/PLd rated for servo/robot"],
        ["Ground bounce","Fast switching currents through PCB inductance → ground voltage shifts\nSeparate power ground and signal ground; join at single star point\nFerrite bead on gate drive VCC; local decoupling cap (100nF ceramic) at each driver"],
      ]}/>

      <InfoBox title="PWM Key Formulae Summary" items={[
        "Duty cycle:          D = t_on / T  →  V_avg = D × V_supply",
        "Frequency:           f_pwm = f_clk / (ARR + 1)  (timer up-count mode)",
        "Resolution:          N = log2(f_clk / f_pwm)  bits",
        "Inductor ripple:     ΔI_L = V_dc × D × (1−D) / (L × f_pwm)  — max at D=0.5",
        "Capacitor ripple:    ΔV_C = ΔI_L / (8 × C × f_pwm)  (CCM, centre-aligned)",
        "Switching loss:      P_sw = ½ × V_ds × I_d × (t_r + t_f) × f_pwm",
        "Conduction loss:     P_cond = I_rms² × R_ds_on  (MOSFET)",
        "Dead-time distortion: ΔV_dt = t_dead × V_dc × f_pwm  (per phase)",
        "Buck gain:           V_out = D × V_in;   Boost: V_out = V_in/(1−D)",
        "SVPWM max M:         M_max = 1.0  (vs 0.866 for SPWM — 15.5% more voltage)",
        "Harmonic amplitude:  |a_n| = (2V_dc)/(nπ) × |sin(nπD)|",
        "LC filter corner:    f_c = 1/(2π√(LC))  — must be << f_pwm",
      ]}/>
    </div>
  );
}